import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import VideoCard from '../components/VideoCard';
import PlayerModal from '../components/PlayerModal';
import { useStore } from '../context/StoreContext';

const Basics = () => {
  const [activeVideo, setActiveVideo] = useState(null);
  const { videos } = useStore();

  // Filter only videos in the "Basics of RocketAlgo" category
  const basicsVideos = videos.filter(v => v.status === 'published' && v.category === 'Basics of RocketAlgo');

  return (
    <div className="min-h-screen bg-[#07090D] flex flex-col font-sans">
      <Navbar />
      
      {/* Mini Hero for Basics */}
      <div className="relative pt-32 pb-16 overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-b from-rocket/10 to-transparent pointer-events-none" />
        <div className="container mx-auto px-4 md:px-8 relative z-10 text-center">
          <span className="text-rocket font-bold text-sm tracking-wider uppercase mb-2 block">Start Here</span>
          <h1 className="text-3xl md:text-5xl font-bold text-white mb-4">Basics of RocketAlgo</h1>
          <p className="text-muted max-w-2xl mx-auto text-sm md:text-base">Master the fundamentals of our platform. Learn how to set up your charts, interpret signals, and build a solid foundation before diving into advanced strategies.</p>
        </div>
      </div>

      <div className="container mx-auto px-4 md:px-8 pb-20 flex-1">
        {basicsVideos.length > 0 ? (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
            {basicsVideos.map(video => (
              <VideoCard 
                key={video.id} 
                video={video} 
                onPlay={(v) => setActiveVideo(v)} 
              />
            ))}
          </div>
        ) : (
          <div className="text-center py-20 text-muted">
            <p>New basic tutorials are being uploaded soon.</p>
          </div>
        )}
      </div>

      <PlayerModal 
        isOpen={!!activeVideo} 
        onClose={() => setActiveVideo(null)} 
        video={activeVideo} 
      />
    </div>
  );
};

export default Basics;